/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class ElasticsearchDataControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation deleteOlderIndices
   */
  static readonly DeleteOlderIndicesPath = '/api/v1/sms-transactions';

  /**
   * Delete older indices from elasticsearch.
   *
   * The API to delete older indices from elasticsearch
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOlderIndices()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOlderIndices$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ElasticsearchDataControllerService.DeleteOlderIndicesPath, 'delete');
    if (params) {
    }

    return this.http.request(rb.build({
     responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete older indices from elasticsearch.
   *
   * The API to delete older indices from elasticsearch
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteOlderIndices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOlderIndices(params?: {
  }): Observable<void> {

    return this.deleteOlderIndices$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
